import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import {
  groupBy, values, filter, defer, find,
  capitalize, lowerFirst, truncate, each,
} from 'lodash';
import {
  Tab, Tabs, DropdownButton, MenuItem,
} from 'react-bootstrap';
import DateTimeDisplay from '../../../../components/date-time-display';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';
import GradientWrapper from '../../../../components/gradient-wrapper';
import RainbowText from '../../../../components/rainbow-text';
import AccountRenderer from '../../../../components/table-cells/AccountNameRenderer';
import ContactRenderer from '../../../../components/table-cells/ContactNameRenderer';
import ExcludeOpportunityForm from '../opportunity-box/ExcludeOpportunityForm';
import { getSavedSearches } from '../../../../components/search-form/search-form-reducer';
import { getColumnData } from '../../../../components/god-table/reducer';
import { getTablePreference } from '../../../App/AppReducer';
import { getTVProductDictionary } from '../../../Setup/SetupReducer';
import { getWinLossOpportunitySurveys, getFeedbackRequestStatus } from '../../../Dashboard/DashboardReducer';
import OpportunityRow from '../opportunity-box/OpportunityRow';
import InternalEmailTab from '../opportunity-box/InternalEmailTab';
import ActionButton from '../opportunity-box/ActionButton';

import AccountLogo from '../account-logo';
import RequestTab from '../opportunity-box/RequestTab';
import FeedbackTab from '../opportunity-box/FeedbackTab';
import JobTab from './JobTab';

import styles from '../opportunity-box/styles.css';

const FEEDBACK_TAB = 'feedbacks';
const PAST_FEEDBACK_TAB = 'pastFeedbacks';
const REQUEST_TAB = 'requests';
const JOB_TAB = 'jobs';
const INTERNAL_EMAIL_TAB = 'internal_emails';
class AccountBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updating: false,
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnLogoLoaded = this.handleOnLogoLoaded.bind(this);
    this.requestAddAccountSurvey = this.requestAddAccountSurvey.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.requestShowOutreachPlan = this.requestShowOutreachPlan.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.includeAccount = this.includeAccount.bind(this);
    this.requestRunTest = this.requestRunTest.bind(this);
    this.requestSendSummaryEmail = this.requestSendSummaryEmail.bind(this);
    this.requestSendReminderEmail = this.requestSendReminderEmail.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.requestPauseReminderEmail = this.requestPauseReminderEmail.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isVisible !== nextProps.isVisible && nextProps.isVisible) {
      this.props.measure();
    }
  }

  getColors() {
    const { colorPallete } = this.props;
    const primaryColor = colorPallete ? colorPallete.vibrant : null;
    const secondaryColor = colorPallete ? colorPallete.darkVibrant || colorPallete.darkMuted : null;
    return { primaryColor, secondaryColor };
  }

  getFeedbacks() {
    // per contact
    const { account } = this.props;
    let reasons = [];
    if (account.feedbacks && account.feedbacks.length) {
      reasons = values(groupBy(filter(account.feedbacks, { is_client: true }), 'contact_id'));
    }
    return reasons;
  }

  getOldFeedbacks() {
    // per contact
    const { account } = this.props;
    let reasons = [];
    if (account.old_feedbacks && account.old_feedbacks.length) {
      reasons = values(groupBy(filter(account.old_feedbacks, { is_client: true }), 'contact_id'));
    }
    return reasons;
  }
  
  requestChangeLanguage(survey, currentLanguage, availableLanguages) {
    return this.props.requestChangeLanguage({ ...survey, object_id: this.props.account.account_id }, currentLanguage, availableLanguages);
  }


  requestPauseReminderEmail(pause = false) {
    const { account } = this.props;
    return this.props.requestPauseReminderEmail(account, pause);
  }

  requestAddAccountSurvey(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    const { account } = this.props;
    this.props.requestAddAccountSurvey(account);
    this.props.onTabSelect(REQUEST_TAB);
  }

  handleTabSelect(tab) {
    this.props.onTabSelect(tab);
    defer(() => {
      this.props.measure();
    });
  }

  requestChangeCommnunicationRecipient() {
    return this.props.requestChangeCommnunicationRecipient(this.props.account);
  }

  includeAccount() {
    return this.props.includeAccount(this.props.account);
  }

  handleOnLogoLoaded(accountLogoUrl, colorPallete) {
    this.props.onLogoLoaded(accountLogoUrl, colorPallete);
  }

  requestShowOutreachPlan(survey) {
    return this.props.requestShowOutreachPlan({ ...survey, object_id: this.props.account.account_id });
  }

  requestChangeSenderEmail(survey) {
    return this.props.requestChangeSenderEmail({ ...survey, object_id: this.props.account.account_id, object: this.props.account });
  }


  requestSendSummaryEmail(automation) {
    const { account } = this.props;
    this.props.requestSendSummaryEmail(account, automation._id);
  }

  requestSendReminderEmail(automation) {
    const { account } = this.props;
    this.props.requestSendReminderEmail(account, automation._id);
  }
  
  requestRunTest(e) {
    const { account } = this.props;
    if (e.preventDefault) {
      e.preventDefault();
      this.props.requestRunTest(account);
    } else {
      this.props.requestRunTest(account, e._id);
    }
  }

  changeStatus(status) {
    if (status !== this.props.account.customer_status) {
      this.setState({ updating: true }, () => {
        this.props.updateAccountStatus(this.props.account, status)
          .then(
            () => {
              this.setState({ updating: false }, this.props.measure);
            },
            () => {
              this.setState({ updating: false }, this.props.measure);
            },
          );
      });
    }
    
  }

  renderStatus() {
    const { account } = this.props;
    const { updating } = this.state;
    
    const items = [
      { value: 'current', label: 'Current Customer', longLabel: 'Current Customer' },
      { value: 'past', label: 'Past Customer', longLabel: 'Past Customer' },
      { value: null, label: 'Prospect', longLabel: 'Prospect' },
    ];
    const activeStatus = find(items, { value: account.customer_status });
    const status = activeStatus ? activeStatus.longLabel : 'Customer Status';
    const disabled = updating;
    const title = updating ? (<Fa name="spinner" spin className="text-muted" />) : (<span className="text-active">{status}</span>);
    return (
      <DropdownButton
        onSelect={this.changeStatus}
        disabled={disabled}
        bsStyle="link"
        bsSize="xs"
        noCaret
        title={title}
        id={`account-status-${account.account_id}`}
      >
        {items.map(l => (
          <MenuItem disabled={disabled} eventKey={l.value} key={l.value} active={account.customer_status === l.value}>
            <span>{l.label}</span>
          </MenuItem>
          ))}
      </DropdownButton>
    );
  }


  renderHeader() {
    const { 
      account, amountField, feedbackRequestStatus, 
      showRunTestButton, showSendSummaryEmailButton, showSendReminderEmailButton,
    } = this.props;
    if (!account) {
      return null;
    }
    const name = (<AccountRenderer data={account} />);
    const logo = (<AccountRenderer data={account}><AccountLogo onLogoLoaded={this.handleOnLogoLoaded} account={account} size={48} /></AccountRenderer>);


    let dateComp = null;
    const status = this.renderStatus();
    let lastOpportunity = 'No pursued opportunities';
    if (account.won_count > 0 && account.last_won_opportunity) {
      lastOpportunity = (<span>Last won opportunity closed <DateTimeDisplay value={account.last_won_opportunity.close_date} relative maxRelativeDifferentDays={360} /></span>);
    } else if (account.lost_count > 0) {
      lastOpportunity = (<span>Pursued <NumberDisplay value={account.lost_count} precision={0} suffix="deal" suffixIsUnit /> with no wins</span>);
    }
    dateComp = (
      <div><span>{status}</span>: {lastOpportunity}</div>
    );

    return (
      <div className={styles.paddingH}>
        <div className={`${styles.bottomLine} clearfix ${styles.paddingV}`}>
          <div className="pull-left">
            <div className={styles.accountSection}>
              <div className={styles.accountPhoto}>
                {logo}
              </div>
              <div className={styles.accountInfo}>
                <div className={styles.accountName}>
                  {name}
                </div>
                <div className={styles.accountDate}>{dateComp}</div>
              </div>
            </div>
          </div>
          <div className="pull-right">
            {!account.exclusion &&
              <div className={styles.headerControls}>
                  <ActionButton
                    object={account}
                    isAccount
                    feedbackRequestStatus={feedbackRequestStatus}
                    requestFeedback={this.requestAddAccountSurvey}
                    requestExclude={() => {
                      this.props.excludeAccount(account);
                    }}
                    requestRunTest={this.props.requestRunTest ? this.requestRunTest : null}
                    enableRunTest={showRunTestButton}

                    enableSummary={showSendSummaryEmailButton}
                    requestSendSummaryEmail={this.requestSendSummaryEmail}

                    enableReminder={showSendReminderEmailButton}
                    requestSendReminderEmail={this.requestSendReminderEmail}

                    enableChangeCommnunicationRecipient={false}
                    requestChangeCommnunicationRecipient={this.requestChangeCommnunicationRecipient}

                    enablePauseReminderEmail
                    requestPauseReminderEmail={this.requestPauseReminderEmail}
                  />
              </div>
            }
            <div className={`text-right ${styles.amountSection}`}><sup className={styles.amountSuffix}>{amountField}</sup><MoneyDisplay value={account[amountField]} abbreviated /></div>
          </div>
        </div>
      </div>
    );
  }

  renderTabs(feedbacks, oldFeedbacks, totalRequests, totalFeedbacks, totalOldFeedbacks, defaultActiveKey) {
    const {
      tab, isVisible, account, isLast, feedbackRequestStatus, internalEmails, emailAutomationsEnabled,
    } = this.props;

    if (account.excluded && totalFeedbacks === 0 && totalRequests === 0) {
      return null;
    }

    const feedbackTitle = totalFeedbacks > 0 ?
      (<span>Current Feedback <span className="badge"><NumberDisplay value={totalFeedbacks} precision={0} /></span></span>) : 'No Feedback';

    const requestTitle = totalRequests > 0 ?
      (<span>Requests <span className="badge"><NumberDisplay value={totalRequests} precision={0} /></span></span>) : 'No Requests';

    const oldFeedbackTitle = totalOldFeedbacks > 0 ?
      (<span>Past Feedback <span className="badge"><NumberDisplay value={totalOldFeedbacks} precision={0} /></span></span>) : 'No Past Feedback';

    const feedbackRequestable = feedbackRequestStatus.feedbackRequestable && !feedbackRequestStatus.loading;

    const isInternalEmailTabActive = defaultActiveKey === INTERNAL_EMAIL_TAB;

    const totalInternalEmails = internalEmails ? internalEmails.length : (account.internal_email_count || 0);

    const internalEmailTabTitle = totalInternalEmails > 0
    ? <NumberDisplay value={totalInternalEmails} suffix="internal email" suffixIsUnit precision={0} />
    : 'No Internal Emails';

    return (
      <div className={`${styles.tabs} ${styles.topLine}`}>
        <Tabs
          defaultActiveKey={defaultActiveKey}
          id={`account-tabs-${account.account_id}`}
          animation={false}
          onSelect={this.handleTabSelect}
          className={styles.tabs}
          activeKey={tab || defaultActiveKey}
          mountOnEnter
          unmountOnExit={false}
        >
          {feedbackRequestStatus.loading && <Tab title={<Fa name="spinner" spin />}></Tab>}
          {(feedbackRequestable || totalFeedbacks > 0) &&
            <FeedbackTab
              eventKey={FEEDBACK_TAB}
              title={feedbackTitle}
              object={account}
              isAccount
              totalFeedbacks={totalFeedbacks}
              measure={this.props.measure}
              feedbacks={feedbacks}
              requestShowInsight={this.props.requestShowInsight}
            />
          }
          {feedbackRequestStatus.loading && <Tab title={<Fa name="spinner" spin />}></Tab>}
          {(feedbackRequestable || totalOldFeedbacks > 0) &&
            <FeedbackTab
              eventKey={PAST_FEEDBACK_TAB}
              title={oldFeedbackTitle}
              object={account}
              isAccount
              includeDate
              isPast
              measure={this.props.measure}
              totalFeedbacks={totalOldFeedbacks}
              feedbacks={oldFeedbacks}
              requestShowInsight={this.props.requestShowInsight}
            />
          }
          {emailAutomationsEnabled &&
            <InternalEmailTab
              eventKey={INTERNAL_EMAIL_TAB}
              title={internalEmailTabTitle}
              object={account}
              totalInternalEmails={totalInternalEmails}
              measure={this.props.measure}
              isActive={isInternalEmailTabActive && isVisible}
              isAccount
            />
          }
          <RequestTab
            eventKey={REQUEST_TAB}
            title={requestTitle}
            object={account}
            isAccount
            totalRequests={totalRequests}
            measure={this.props.measure}
            requestAddSurvey={this.props.requestAddAccountSurvey}
            isActive={defaultActiveKey === REQUEST_TAB && isVisible}
            requestShowOutreachPlan={this.requestShowOutreachPlan}
            requestChangeSenderEmail={this.requestChangeSenderEmail}
            requestChangeLanguage={this.requestChangeLanguage}
            requestCancelContact={this.props.requestCancelContact}
            surveyControlDropup={isLast}
            showAddButton={feedbackRequestable}
            feedbackRequestStatus={this.props.feedbackRequestStatus}
          />
          <JobTab
            eventKey={JOB_TAB}
            title="Job to be Done"
            account={account}
            measure={this.props.measure}
            isActive={defaultActiveKey === JOB_TAB && isVisible}
          />
        </Tabs>
      </div>
    );
  }

  renderValueLine(totalFeedbacks, feedbacks) {
    // let inner = (<span>Unknown value and experience state</span>);
    let inner = null;
    if (totalFeedbacks > 0) {
      let mostRecentFeedback = feedbacks[0];
      if (mostRecentFeedback) {
        [mostRecentFeedback] = mostRecentFeedback;
        const effortToLevel = mostRecentFeedback.effort_level; // https://github.com/lumen-software/TruSales/issues/1056
        if (effortToLevel !== 'unknown' && effortToLevel !== 'empty' && effortToLevel !== null && effortToLevel !== undefined) {
          const contactName = (
            <strong>
              <ContactRenderer value={mostRecentFeedback.contact_name} data={{ contact_id: mostRecentFeedback.sfa__contact_id }} />
            </strong>
          );
          let cls = null;
          if (mostRecentFeedback.value_direction === 'Decreasing' && (mostRecentFeedback.value_level === 'Little' || mostRecentFeedback.value_level === 'None')) {
            cls = 'text-danger';
          } else if (mostRecentFeedback.value_level === 'Great') {
            cls = 'text-success';
          }
          const valueComp = (<span className={cls}>{mostRecentFeedback.effort_to_value}</span>);
          inner = (
            <span>Effort <span className={styles.ampersand}>&amp;</span> Value Experience for {contactName}: {valueComp}</span>
          );
        }
      }
    }

    return inner;
  }

  renderExcludeMessage() {
    const { account, auth } = this.props;
    if (!account.exclusion) {
      return null;
    }
    return (
      <div key="exclude" className={styles.section}>
        <ExcludeOpportunityForm
          opportunity={account}
          auth={auth}
          isModal={false}
          isAccount
          requestInclude={this.includeAccount}
        />
      </div>
    );
  }

  renderRows(totalFeedbacks, feedbacks) {
    const { rows, account, rowData, productDictionary, surveys } = this.props;
    const visiableRows = filter(rows, { is_visible: true });
    const valueLine = this.renderValueLine(totalFeedbacks, feedbacks);


    const tableRows = [];
    each(visiableRows, (row) => {
      tableRows.push((
        <OpportunityRow
          surveys={surveys}
          rowData={rowData}
          row={row}
          productDictionary={productDictionary}
          opportunity={account}
          key={row._id}
          isAccount
          requestAddOpportunitySurveyForContact={this.requestAddOpportunitySurveyForContact}
        />
      ));
    });

    if (!valueLine && tableRows.length === 0) {
      return null;
    }

    return (
      <div className={styles.section}>
        <table className="table table-condensed" style={{ margin: 0 }}>
          <tbody>
            {valueLine !== null &&
              <tr>
                <td colSpan="2">{valueLine}</td>
              </tr>
            }
            {tableRows}
          </tbody>
        </table>
      </div>
    );
  }


  renderBody(totalFeedbacks, totalRequests, feedbacks) {
    const { account } = this.props;
    const { primaryColor, secondaryColor } = this.getColors();
    let titleComp = (
      <div>
        <strong><span>Need to <a href="" onClick={this.requestAddAccountSurvey}>request feedback</a> on current experience.</span></strong>.
      </div>
    );
    titleComp  = null;
    if (account.exclusion) {
      titleComp = null;
    }
    let shouldRenderRainbowText = false;
    let shouldRenderBackground = false;

    if (totalFeedbacks > 0) {
      titleComp = feedbacks.map((mFeedbacks) => {
        const feedback = mFeedbacks[0];
        
        const contactName = (<strong><ContactRenderer value={feedback.contact_name} data={{ contact_id: feedback.sfa__contact_id }} /></strong>);
        
        const dateComp = (<span>as of <a target="_blank" href={feedback.overview_url}><DateTimeDisplay value={feedback.publish_date} format="long" /> <sup><Fa name="external-link" /></sup></a></span>);
        // https://github.com/lumen-software/TruSales/issues/1145
        const strength = !feedback.experience_strength || feedback.experience_strength === 'Unknown' ? '' : capitalize(feedback.experience_strength);
        const cond = !feedback.experience_condition || feedback.experience_condition === 'Unknown' ? 'Feedback on' : capitalize(feedback.experience_condition);

        const epx2 = lowerFirst(feedback.experience_type);

        const isPositive = feedback.classification_text === 'Positive';
        const isNegative = feedback.classification_text === 'Negative';
   
        let cls = null;
        if (isPositive) {
          cls = 'text-success';
        } else if (isNegative) {
          cls = 'text-danger';
        }
        return (
          <div key={feedback.id}>
            <span className={cls}>{strength} {cond}</span> {epx2} experience for {contactName} {dateComp}
          </div>
        );
      });
      shouldRenderBackground = true;
    } else if (totalRequests > 0) {
      titleComp = (
        <div>
          <strong>
            Requested experience feedback from {(totalRequests === 1 ? 'one contact' : `${totalRequests} contacts`)}.
          </strong>
        </div>
      );
      shouldRenderRainbowText = true;
    }

    const comp = (
      <div key="title" className={styles.section}>
        <div className={styles.mainTitle}>{titleComp}</div>
      </div>
    );
    

    let body = [];
    if (shouldRenderBackground) {
      body = [
        (
          <GradientWrapper
            key="main"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            className={styles.vibrantBackground}
            onMounted={this.props.measure}
            withPattern
          >
            {comp}
          </GradientWrapper>
        ),
        this.renderExcludeMessage(),
      ];
    } else if (shouldRenderRainbowText) {
      body = [
        (
          <RainbowText
            key="main"
            id={account.account_id}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            className={styles.rainbowText}
            onMounted={this.props.measure}
          >
            {comp}
          </RainbowText>
        ),
        this.renderExcludeMessage(),
      ];
    } else {
      body = [
        (<div key="main" className={styles.plain} />),
        // comp, // https://github.com/lumen-software/TruSales/issues/1554
        this.renderExcludeMessage(),
      ];
    }

    return (
      <div className={styles.sectionBody}>
        {body}
        {this.renderRows(totalFeedbacks, feedbacks)}
      </div>
    );
  }

  render() {
    const { collectorStats, tab } = this.props;
    const cls = [styles.box];

    const feedbacks = this.getFeedbacks();
    const totalFeedbacks = feedbacks.length;
    const oldFeedbacks = this.getOldFeedbacks();
    const totalOldFeedbacks = oldFeedbacks.length;

    let totalRequests = 0;
    let defaultActiveKey = tab;

    if (totalFeedbacks > 0) {
      if (!defaultActiveKey) {
        defaultActiveKey = FEEDBACK_TAB;
      }
    }
    if (collectorStats.total) {
      totalRequests = collectorStats.total;
      if (totalFeedbacks === 0 && !defaultActiveKey) {
        defaultActiveKey = REQUEST_TAB;
      }
    }

    if (!defaultActiveKey && totalOldFeedbacks.length > 0) {
      defaultActiveKey = PAST_FEEDBACK_TAB;
    }

    return (
      <div className={styles.spacing}>
        <div className={cls.join(' ')}>
          {this.renderHeader()}
          {this.renderBody(totalFeedbacks, totalRequests, feedbacks)}
          {this.renderTabs(feedbacks, oldFeedbacks, totalRequests, totalFeedbacks, totalOldFeedbacks, defaultActiveKey)}
        </div>
      </div>
    );
  }
}

AccountBox.propTypes = {
  account: PropTypes.shape({
    account_id: PropTypes.string.isRequired,
    customer_status: PropTypes.string,
  }).isRequired,
  amountField: PropTypes.string,
  collectorStats: PropTypes.shape({}),
  measure: PropTypes.func,
  onTabSelect: PropTypes.func,
  tab: PropTypes.string,
  colorPallete: PropTypes.shape({}),
  onLogoLoaded: PropTypes.func,
  requestShowInsight: PropTypes.func,
  requestAddAccountSurvey: PropTypes.func,
  isVisible: PropTypes.bool,
  auth: PropTypes.shape({}).isRequired,
  updateAccountStatus: PropTypes.func,
  selectedFilter: PropTypes.string,
  requestShowOutreachPlan: PropTypes.func,
  isLast: PropTypes.bool,
  requestChangeSenderEmail: PropTypes.func,
  requestCancelContact: PropTypes.func,
  requestChangeLanguage: PropTypes.func,
  excludeAccount: PropTypes.func,
  showRunTestButton: PropTypes.bool,
  requestRunTest: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.shape({})),
  rowData: PropTypes.shape({}),
  productDictionary: PropTypes.shape({}),
  surveys: PropTypes.arrayOf(PropTypes.shape({})),
  savedSearches: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  feedbackRequestStatus: PropTypes.shape({}),
  emailAutomationsEnabled: PropTypes.bool,
  showSendSummaryEmailButton: PropTypes.bool,
  showSendReminderEmailButton: PropTypes.bool,
  requestSendReminderEmail: PropTypes.func,
  requestSendSummaryEmail: PropTypes.func,
  requestPauseReminderEmail: PropTypes.func,
};

AccountBox.defaultProps = {
  selectedFilter: null,
  collectorStats: {},
  amountField: 'ttm',
  colorPallete: {},
  measure: () => {},
  onTabSelect: () => {},
  onLogoLoaded: () => {},
  requestCancelContact: () => {},
  tab: null,
  requestShowInsight: () => {},
  requestAddAccountSurvey: () => {},
  requestChangeLanguage: () => {},
  isVisible: false,
  updateAccountStatus: () => Promise.reject(new Error('need handler')),
  requestShowOutreachPlan: () => Promise.reject(new Error('Need handler')),
  isLast: false,
  requestChangeSenderEmail: () => {},
  excludeAccount: () => {},
  showRunTestButton: false,
  requestRunTest: null,
  savedSearches: [],
  rows: [],
  rowData: {},
  surveys: [],
  productDictionary: {},
  feedbackRequestStatus: {},
  emailAutomationsEnabled: false,
  showSendSummaryEmailButton: false,
  showSendReminderEmailButton: false,
  requestSendReminderEmail: () => {},
  requestSendSummaryEmail: () => {},
  requestPauseReminderEmail: () => {},
};

function mapStateToProps(state, ownProps) {
  return {
    rows: getTablePreference(state, 'account-feedback-tile'),
    rowData: getColumnData(state),
    productDictionary: getTVProductDictionary(state),
    savedSearches: getSavedSearches('feedback/experience', state),
    surveys: getWinLossOpportunitySurveys(state, ownProps.account.account_id),
    feedbackRequestStatus: getFeedbackRequestStatus(state, ownProps.account.account_id),
  };
}


export default connect(mapStateToProps)(AccountBox);
